import React from 'react'
import { TextField } from '@material-ui/core'
import useCurrentUserProp from 'hooks/useCurrentUserProp'
import { useController } from 'react-hook-form'

export default function FirstName({ control, ...passThroughProps }) {
  const defaultValue = useCurrentUserProp('firstName') || ''
  const { field, fieldState: { error, invalid } } = useController({
    name: 'firstName',
    defaultValue,
    control,
    rules: {
      required: { value: true, message: 'Required' }
    }
  })

  return (
    <TextField
      {...field}
      autoComplete='first-name'
      label='First Name'
      type='text'
      margin='dense'
      required
      helperText={error?.message || '*Required'}
      error={invalid}
      {...passThroughProps}
    />
  )
}
